export type ViewerId = 'owner' | 'write' | 'read';

export interface Viewer {
    id: ViewerId;
    label: string;
    description: string;
    canWrite: boolean;
}

export const VIEWERS: Record<ViewerId, Viewer> = {
    owner: {
        id: 'owner',
        label: 'Propriétaire',
        description: 'Propriétaire du réseau : consultation, création, modification et suppression.',
        canWrite: true,
    },
    write: {
        id: 'write',
        label: 'Écriture',
        description: 'Membre d’un groupe « Modifiable par » : consultation, création, modification et suppression.',
        canWrite: true,
    },
    read: {
        id: 'read',
        label: 'Lecture',
        description: 'Membre d’un groupe « Consultable par » : consultation sans action de modification.',
        canWrite: false,
    },
};

export const VIEWER_IDS = Object.keys(VIEWERS) as ViewerId[];

export function isViewerId(value: string | null): value is ViewerId {
    return value !== null && (VIEWER_IDS as string[]).includes(value);
}
